import { customersApi, analysesApi, locationsManagementApi } from '@/api';

export default {
  methods: {
    async searchCustomer({ text, cb, field, exact }) {
      if (text.length < 3) {
        cb([]);
        return;
      }
      try {
        const response = await customersApi.autocompleteFetch(
          field,
          text,
          exact
        );
        const customers = response.data.map((c) => ({
          value: c.id,
          label: c[field],
          code: `${c.id}`,
          customerName: c.name,
        }));
        cb(customers);
      } catch (error) {
        cb([]);
      }
    },
    async searchAnalyses({ text, cb, field }) {
      if (text.length < 3) {
        cb([]);
        return;
      }
      try {
        const response = await analysesApi.autocompleteFetch(
          field,
          text,
          false
        );
        const analyses = response.data.map((a) => ({
          value: a.id,
          code: a.code,
          description: a.description,
          method: a.method,
          accreditedTest: a.accreditedTest,
          instrument: a.brand,
        }));
        cb(analyses);
      } catch (error) {
        cb([]);
      }
    },
    async locationsList(value, cb) {
      if (!value || value.length < 3) {
        cb([]);
        return;
      }
      try {
        const response = await locationsManagementApi.autocompleteFetch(
          'name',
          value,
          false
        );
        const locations = response.data.map((c) => ({
          label: c.name,
          value: c.id,
        }));
        cb(locations);
      } catch (error) {
        cb([]);
      }
    },
    async searchBrand(value, cb) {
      try {
        const response = await analysesApi.brandsAutocompleteFetch(value);
        const brands = response.data.map((item) => ({
          label: item.brand,
          key: item.brandCode,
          value: item.brandCode,
        }));
        cb(brands);
      } catch (error) {
        cb([]);
      }
    },
    async searchMethod(value, cb) {
      try {
        const response = await analysesApi.methodsAutocompleteFetch(value);
        const methods = response.data.map((item) => ({
          label: item.method,
          key: item.methodCode,
          value: item.methodCode,
        }));
        cb(methods);
      } catch (error) {
        cb([]);
      }
    },
  },
};
